var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMulionOfoghiSarasari(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.5,26.1c-0.3,0-0.5-0.2-0.5-0.5V24c0-0.3,0.2-0.5,0.5-0.5S16,23.8,16,24v1.6C16,25.9,15.8,26.1,15.5,26.1z M15.5,22.8 c-0.3,0-0.5-0.2-0.5-0.5v-1.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.7C16,22.6,15.8,22.8,15.5,22.8z M15.5,19.5 c-0.3,0-0.5-0.2-0.5-0.5v-1.7c0-0.3,0.2-0.5,0.5-0.5S16,17,16,17.3V19C16,19.3,15.8,19.5,15.5,19.5z M15.5,16.1 c-0.3,0-0.5-0.2-0.5-0.5v-1.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.7C16,15.9,15.8,16.1,15.5,16.1z M15.5,12.8 c-0.3,0-0.5-0.2-0.5-0.5v-1.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.7C16,12.5,15.8,12.8,15.5,12.8z M15.5,9.4 c-0.3,0-0.5-0.2-0.5-0.5V7.2c0-0.3,0.2-0.5,0.5-0.5S16,6.9,16,7.2v1.7C16,9.2,15.8,9.4,15.5,9.4z M15.5,6C15.3,6,15,5.8,15,5.5 V3.9c0-0.3,0.2-0.5,0.5-0.5S16,3.6,16,3.9v1.7C16,5.8,15.8,6,15.5,6z M15.5,2.7c-0.3,0-0.5-0.2-0.5-0.5V0.5C15,0.2,15.3,0,15.5,0 S16,0.2,16,0.5v1.7C16,2.4,15.8,2.7,15.5,2.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.4,26.1c-0.3,0-0.5-0.2-0.5-0.5V24c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.6C8.9,25.9,8.6,26.1,8.4,26.1z M8.4,22.8 c-0.3,0-0.5-0.2-0.5-0.5v-1.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.7C8.9,22.6,8.6,22.8,8.4,22.8z M8.4,19.5 c-0.3,0-0.5-0.2-0.5-0.5v-1.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5V19C8.9,19.3,8.6,19.5,8.4,19.5z M8.4,16.1 c-0.3,0-0.5-0.2-0.5-0.5v-1.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.7C8.9,15.9,8.6,16.1,8.4,16.1z M8.4,12.8 c-0.3,0-0.5-0.2-0.5-0.5v-1.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.7C8.9,12.5,8.6,12.8,8.4,12.8z M8.4,9.4 c-0.3,0-0.5-0.2-0.5-0.5V7.2c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.7C8.9,9.2,8.6,9.4,8.4,9.4z M8.4,6C8.1,6,7.9,5.8,7.9,5.5 V3.9c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.7C8.9,5.8,8.6,6,8.4,6z M8.4,2.7c-0.3,0-0.5-0.2-0.5-0.5V0.5C7.9,0.2,8.1,0,8.4,0 s0.5,0.2,0.5,0.5v1.7C8.9,2.4,8.6,2.7,8.4,2.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.7,26.1c-0.3,0-0.5-0.2-0.5-0.5V24c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.6C23.2,25.9,23,26.1,22.7,26.1z  M22.7,22.8c-0.3,0-0.5-0.2-0.5-0.5v-1.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.7C23.2,22.6,23,22.8,22.7,22.8z M22.7,19.5 c-0.3,0-0.5-0.2-0.5-0.5v-1.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5V19C23.2,19.3,23,19.5,22.7,19.5z M22.7,16.1 c-0.3,0-0.5-0.2-0.5-0.5v-1.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.7C23.2,15.9,23,16.1,22.7,16.1z M22.7,12.8 c-0.3,0-0.5-0.2-0.5-0.5v-1.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.7C23.2,12.5,23,12.8,22.7,12.8z M22.7,9.4 c-0.3,0-0.5-0.2-0.5-0.5V7.2c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.7C23.2,9.2,23,9.4,22.7,9.4z M22.7,6 c-0.3,0-0.5-0.2-0.5-0.5V3.9c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.7C23.2,5.8,23,6,22.7,6z M22.7,2.7c-0.3,0-0.5-0.2-0.5-0.5 V0.5c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.7C23.2,2.4,23,2.7,22.7,2.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.1,
    y: 12.6,
    width: 5.4,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.6,
    y: 12.6,
    width: 5.4,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16.6,
    y: 12.6,
    width: 5.4,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 12.6,
    width: 5.4,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.8,
    y: 26.8,
    width: 22.3,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "4.6,30 0,27.3 4.6,24.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "25.4,30 30,27.3 25.4,24.6  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulionOfoghiSarasari);
export default __webpack_public_path__ + "static/media/mulion_ofoghi_sarasari.fef5533c73c6d6d142b0de01cdeed208.svg";
export { ForwardRef as ReactComponent };